module.exports = __webpack_public_path__ + "static/hinted-AvenirNext-Bold.37ca0aa9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/hinted-AvenirNext-Bold.ttf
// module id = 198
// module chunks = 104101334113578 114276838955818